import type { DigitalSampleAsset } from "../hooks/digital-samples";

export const downloadAsset = (
  asset: DigitalSampleAsset,
  onChangeId?: (id: string) => void,
  onDownloadState?: (result: string) => void,
  onDownloadLoading?: (value: boolean) => void,
  onSuccess?: () => void,
) => {
  onChangeId?.(asset.id);
  onDownloadState?.("DOWNLOADING");
  fetch(asset.assetUrl)
    .then((response) => {
      if (response.ok) {
        const link = document.createElement("a");
        link.download = asset.fileName;
        link.href = asset.assetUrl;
        link.click();
        onDownloadState?.("DOWNLOADED");
        // Fires when the browser-initiated download starts (link.click
        // succeeded), not when the file lands on disk — the browser owns
        // the transfer after this point and we can't observe completion.
        onSuccess?.();
      } else {
        onDownloadState?.("DOWNLOAD_FAILED");
      }
      onDownloadLoading?.(false);
    })
    .catch(() => {
      onDownloadState?.("DOWNLOAD_FAILED");
      onDownloadLoading?.(false);
    });
};
